<template>
    <fragment >
      <search-nav-start-end label="작성일" v-model="nav.inputA_5"/>
    </fragment>
    </template>

<script>
import SearchNavStartEnd from '@/views/list/components/SearchNavStartEnd'

export default {
  name: 'NormalSearchNav54',
  components:{
    SearchNavStartEnd
  },
  watch: {
    nav: {
      immediate: true,
      deep: true,
      handler() {
        this.$emit('input', this.nav)
      }
    }
  },
  data() {
    return {
      nav: {
        inputA_5: {}
      }
    }
  }
}
</script>

    <style scoped>

    </style>
